const accentStyles = {
  amber: {
    bar: 'bg-amber-500',
    label: { dark: 'text-amber-400', light: 'text-amber-700' },
    border: { dark: 'border-slate-700/80', light: 'border-slate-200' },
    surface: { dark: 'bg-slate-900/40', light: 'bg-slate-50' },
  },
  cyan: {
    bar: 'bg-cyan-500',
    label: { dark: 'text-cyan-400', light: 'text-cyan-700' },
    border: { dark: 'border-slate-700/80', light: 'border-slate-200' },
    surface: { dark: 'bg-slate-900/40', light: 'bg-slate-50' },
  },
  indigo: {
    bar: 'bg-indigo-500',
    label: { dark: 'text-indigo-400', light: 'text-indigo-700' },
    border: { dark: 'border-slate-700/80', light: 'border-slate-200' },
    surface: { dark: 'bg-slate-900/40', light: 'bg-slate-50' },
  },
  neutral: {
    bar: 'bg-slate-400',
    label: { dark: 'text-slate-400', light: 'text-slate-600' },
    border: { dark: 'border-slate-700/80', light: 'border-slate-200' },
    surface: { dark: 'bg-slate-900/40', light: 'bg-slate-50' },
  },
};

/**
 * Executive summary block — consistent typography and layout across the site.
 * Format aligned to consulting deliverables: single type family, restrained hierarchy,
 * label + prose body, generous line height for executive reading.
 */
const ExecutiveSummary = ({
  children,
  lead,
  sections = [],
  theme = 'dark',
  variant = 'neutral',
  className = '',
}) => {
  const isDark = theme === 'dark';
  const mode = isDark ? 'dark' : 'light';
  const accent = accentStyles[variant] || accentStyles.neutral;
  const bodyText = lead || children;

  return (
    <div
      className={`exec-summary border ${accent.border[mode]} ${accent.surface[mode]} ${className}`}
    >
      <div className="flex items-start gap-5 sm:gap-6">
        <div className={`exec-summary-accent ${accent.bar}`} aria-hidden />
        <div className="flex-1 min-w-0 pt-0.5">
          <p className={`exec-summary-label ${accent.label[mode]}`}>Executive Summary</p>

          {bodyText && (
            <p className={`exec-summary-body mt-5 ${isDark ? 'text-slate-200' : 'text-slate-800'}`}>
              {bodyText}
            </p>
          )}

          {sections.length > 0 && (
            <dl className={`mt-8 space-y-6 border-t pt-8 ${isDark ? 'border-slate-700/50' : 'border-slate-200'}`}>
              {sections.map((section) => (
                <div key={section.title}>
                  <dt
                    className={`exec-summary-section-label ${
                      isDark ? 'text-slate-300' : 'text-slate-700'
                    }`}
                  >
                    {section.title}
                  </dt>
                  <dd
                    className={`exec-summary-body mt-2 ${isDark ? 'text-slate-300' : 'text-slate-600'}`}
                  >
                    {section.body}
                  </dd>
                </div>
              ))}
            </dl>
          )}
        </div>
      </div>
    </div>
  );
};

export default ExecutiveSummary;
